/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 3.2.1263 on 2025-02-03 21:38:58.

export interface AdminSettings {
    settingsId: number;
    settings: string;
}

export interface AdminSettingsResponse {
    adminSettings: AdminSettings[];
}

export interface AdminUpdateResponse {
    status: boolean;
}

export interface Album {
    id: string;
    owner: string;
    name: string;
    seriesId: number;
    createdTimestamp: string;
    allowSharing: boolean;
    sharedDomains: number[];
}

export interface AlbumPhoto {
    id: string;
    albumId: string;
    photoId: string;
}

export interface AlbumPhotoRequest {
    id: string;
    albumId: string;
    photoId: string;
}

export interface AlbumRequest {
    id: string;
    name: string;
    seriesId: number;
    allowSharing: boolean;
    sharedDomains: number[];
}

export interface AlbumResponseStatus {
    status: boolean;
}

export interface Alert {
    title: AlertTitle;
    lap: number;
    vehicleNumber?: string;
    leaderLap: number;
    type: AlertType;
    timestamp: number;
    description: string;
}

export interface AlertData extends Alert {
}

export interface AlertKey {
    seriesType: SeriesType;
    runType: RunType;
}

export interface AlertKt {
}

export interface AlertLiveStreamKey {
    alertType: AlertType;
    seriesType: SeriesType;
    runType: RunType;
}

export interface AlertMessage extends Alert, Message, Comparable<AlertMessage> {
}

export interface AlertReplayResponse {
    alertDataSet: Alert[];
}

export interface AlertRequest extends BaseRequest {
    flagRequest?: FlagAlertRequest;
    pitRequest?: PitAlertRequest;
    audioRequest?: AudioAlertRequest;
    lapSearchRequest?: LapSearchRequest;
    titleSearch?: TextSearchRequest[];
    descriptionSearch?: TextSearchRequest[];
    lapActivityRequest?: LapActivityRequest;
    seriesType: SeriesType;
    runType: RunType;
    eventId: string;
}

export interface AudioAlertRequest {
    keywords?: string[];
    vehicleNumbers?: string[];
}

export interface BaseRequest {
    sessionId: string;
}

export interface BasicSession {
    seriesType: SeriesType;
    runType: RunType;
    raceId?: string;
    sessionId?: string;
}

export interface BasicSessionInfo extends BasicSession {
}

export interface Caution {
    race_id: number;
    start_lap: number;
    end_lap: number;
    reason: string;
    comment: string;
    beneficiary_car_number?: string;
    flag_state: number;
}

export interface ClearCacheDetails {
    lastManualClearTime?: number;
}

export interface ClearCacheRequest {
    forceClearCache: boolean;
}

export interface ClearCacheResponse {
    liveEventRunning: boolean;
}

export interface ClearCommonProcessorCacheResponse {
    status: boolean;
}

export interface ClearReplayCacheRequest extends ReplayRequest {
}

export interface ConsumerKey {
    seriesType: SeriesType;
    originType: OriginType;
}

export interface DateRangeTimestamps {
    threeDaysPrior: number;
    oneDayAfter: number;
}

export interface DefaultWorkspaceResponse {
    workspaces: Record<SanctioningBodyEnum, Workspace>;
}

export interface DeltaMetadata {
    vehicleNumber: string;
    currentDeltaMap: Record<string, number>;
    vehicleBestLapDeltaMap: Record<string, Record<string, number>>;
}

export interface DriverCompareTrack {
    trackId: string;
    trackWalls: string;
    trackLine: string;
    trackSectors: string;
    trackOrientation: string;
}

export interface DriverCompareWorkspace {
    userId: string;
    id: string;
    workspace: string;
    createdTimestamp?: Date;
    updatedTimestamp?: Date;
    slug: string;
    configName: string;
    displaySettings: string;
}

export interface DriverPoints {
    driverName: string;
    points: number;
    isContender: boolean;
    playoffRank: number;
    driverId: string;
    contender: boolean;
}

export interface DriverPointsData extends Message {
    vehicleNumber: string;
    deltaLeader?: number;
    deltaNext?: number;
    firstName?: string;
    driverId?: number;
    isInChase?: boolean;
    isPointsEligible?: boolean;
    isRookie?: boolean;
    lastName?: string;
    membershipId?: number;
    points?: number;
    pointsPosition?: number;
    pointsEarnedThisRace?: number;
    stageOnePoints?: number;
    stageOneWinner?: boolean;
    stageTwoPoints?: number;
    stageTwoWinner?: boolean;
    stageThreePoints?: number;
    stageThreeWinner?: boolean;
    wins?: number;
    topFive?: number;
    topTen?: number;
    poles?: number;
    preRaceRanking?: number;
    preRaceWins?: number;
    preRacePlayoffPoints?: number;
    preRacePoints?: number;
    currentPointsRanking?: number;
    bonusPoints?: number;
    accruedPoints?: number;
    pointsAtStart?: number;
    inChase: boolean;
    pointsEligible: boolean;
    rookie: boolean;
}

export interface DriverVehicleSeriesData {
    driverId: string;
    vehicleNumber: string;
    driverName: string;
    manufacturer: string;
    seriesId: string;
}

export interface DriverVehicleSeriesDataResponse {
    driverVehicleSeriesData: DriverVehicleSeriesData[];
}

export interface EntriesDataResponse {
    entriesData: LapData[];
}

export interface EntryList {
    driver_id: number;
    crew_chief_id: number;
    crew_chief_fullname: string;
    team_id: number;
    team_comp_id: number;
    vehicle_number: string;
    driver_name: string;
    driver_hometown: string;
    hometown_city: string;
    hometown_state: string;
    hometown_country: string;
    owner_name: string;
    team_name: string;
    manufacturer: string;
    modified: Date;
    pit_crew: PitCrewMember[];
    road_crew: RoadCrewMember[];
    qualifying_group_order: number;
    qualifying_group?: string;
    practice_group?: string;
}

export interface Error {
    message: string;
    errorCode: string;
    clientRequestId: string;
}

export interface ErrorMessage {
    statusCode: number;
    message: string;
}

export interface Event {
    eventId: string;
    eventName: string;
    eventDate: string;
    trackId: string;
    trackEventId: string;
}

export interface EventDriverNameVehicleNumber {
    driverFullName: string;
    vehicleNumber: string;
}

export interface EventSessionDetailsResponse {
    session: Session;
    event: Event;
    track: Track;
}

export interface EventSessions {
    eventId: string;
    eventName: string;
    eventDate: string;
    trackId: string;
    trackName: string;
    trackEventId: string;
    sessionIds: string[];
}

export interface EventSessionsStatusResponse {
    eventId: string;
    sessionList: Session[];
}

export interface EventsResponse {
    events: EventSessions[];
    sessions: Session[];
}

export interface ExtensionsKt {
}

export interface FastDataResponse {
    fastDataMap: Record<number, LapAnalysisData>;
    defaultThreshold: number;
}

export interface FeedStatusData extends Message {
    feedStatus: FeedStatusType;
    feedStatusOrigin: OriginType;
    problematicPartitions: string[];
}

export interface FlagAlertRequest {
}

export interface GapMetadata {
    vehicleNumber: string;
    gap: number;
}

export interface GetSessionDBInfoRequest {
    sessionId: string;
}

export interface GetSessionDBInfoResponse {
    sessionDBInfo?: SessionDBInfo;
    status: boolean;
    message: string;
}

export interface GetWeekendSessionsRequest {
    sanctioningBodyId: SanctioningBodyEnum;
}

export interface GetWeekendSessionsResponse {
    status: boolean;
    message: string;
}

export interface GreenCalc {
    value: number;
    lineCrossing: string;
}

export interface GreenSingle {
    vehicleNumber: string;
    lapNumber: number;
    greenCalc: GreenCalc;
}

export interface Group {
    groupName: string;
    numLaps: number;
    timePerGroup: number;
}

export interface ImageGalleryEventSettings {
    eventId: string;
    sessionToSettingsMap: Record<string, ImageGallerySessionSettings>;
}

export interface ImageGallerySessionSettings {
    order: number;
    folders: string[];
}

export interface IndyWeatherStations {
    startDate?: string;
    endDate?: string;
    stations: Record<string, string>;
    id?: string;
}

export interface IndyWindData {
    stationId: string;
    stationAlias: string;
    timestamp: number;
    windSpeed: number;
    windDirection: number;
    latitude: number;
    longitude: number;
}

export interface InsertQualifyingEntriesRequest {
    eventId?: string;
    raceId?: number;
    sessionId?: string;
}

export interface InsertQualifyingEntriesResponse {
    status: boolean;
    message: string;
}

export interface LapActivityRequest {
    luckyDogRequest?: LuckyDogRequest;
}

export interface LapAnalysisAvgSingle {
    vehicleNumber: string;
    avgLapTime: number;
    avgLapRank: number;
}

export interface LapAnalysisData {
    numLaps: number;
    threshold: number;
    lapData: Record<string, LapAnalysisSingle>;
}

export interface LapAnalysisRequest {
    requestedLapNumber?: number;
    threshold?: number;
    streamInfo: StreamInfo;
    isReplay: boolean;
    isConsecutive?: boolean;
    runName?: string;
}

export interface LapAnalysisSingle {
    vehicleNumber: string;
    lapTime: number;
    lapDiff: number;
    lapRank: number;
}

export interface LapAnalysisStats {
    slow: number;
    medium: number;
    fast: number;
}

export interface LapData extends SimpleLap, Message {
    pitPositionMetadata: PitPositionData;
    tireAgeMetadata: TireAgeMetadata;
    luckyDog?: boolean;
    inGarage?: boolean;
    isInactive?: boolean;
    startFinish: boolean;
    pitLap: boolean;
    inactive: boolean;
}

export interface LapDeltaData extends Message {
    vehicleNumber: string;
    runningPosition: number;
    lapsCompleted: number;
    driverFullName: string;
    deltaToTarget: number;
    lastLapTime: number;
    bestLapTime: number;
    isStartFinish: boolean;
    elapsedTime: number;
    loopName: string;
    flag: FlagType;
    isPitLap: boolean;
    runName: string;
    groupName: string;
    deltaMetadata: DeltaMetadata;
    startFinish: boolean;
    pitLap: boolean;
}

export interface LapHistData extends Message {
    lap: number;
    leaderLapFlag: number;
    vehicleMetaDataList: VehicleMetaData[];
    driverCount: number;
    timestampMetadata: TimestampMetadata;
}

export interface LapLeader {
    start_lap: number;
    end_lap: number;
    car_number: string;
    race_id: number;
}

export interface LapSearchRequest {
    startingLap: number;
    endingLap: number;
    exclude: boolean;
}

export interface LineCrossing {
    lineCrossingId: string;
    pb_long: number;
    lat: number;
    avgFrac: number;
    category: string;
}

export interface LiveStreamInfo {
    session: BasicSessionInfo;
    origins: OriginType[];
}

export interface LiveStreamKey {
    seriesType: SeriesType;
    runType: RunType;
    originType: OriginType;
}

export interface LuckyDogRequest {
    exclude: boolean;
}

export interface ManufacturerPoints extends Message {
    position: number;
    manufacturer: string;
    points: number;
}

export interface ManufacturerPointsData {
    position: number;
    manufacturer: string;
    points: number;
}

export interface Message {
    sessionInfo: SessionInfo;
    messageInfo: MessageInfo;
}

export interface MessageInfo {
    messageType: MessageType;
    originType: OriginType;
}

export interface MinimalLap {
    vehicleNumber: string;
    runningPosition: number;
    lapsCompleted: number;
    lastLapTime: number;
    elapsedTime: number;
    isPitLap: boolean;
    runName: string;
    groupName: string;
    flag: FlagType;
    timeOfDay: number;
}

export interface MinimalLapData extends MinimalLap {
    pitLap: boolean;
}

export interface ModifySessionRequest extends ModifySessionRequestInterface {
}

export interface ModifySessionRequestInterface {
    sessionOverrides: BasicSessionInfo[];
    sessionBlobPath: string;
}

export interface ModifySessionResponse extends ModifySessionResponseInterface {
}

export interface ModifySessionResponseInterface {
    success: boolean;
    message: string;
}

export interface OwnerPoints extends Message {
    ownerName: string;
    points: number;
    bonusPoints: number;
    starts: number;
    poles: number;
    wins: number;
    top5: number;
    top10: number;
    dnf: number;
    rank: number;
    ownerId: number;
    ownerFirstName: string;
    ownerLastName: string;
    vehicleNumber: string;
}

export interface PitAlertRequest {
    vehicleNumbers?: string[];
}

export interface PitCrewMember {
    full_name: string;
    position: string;
    home_track: string;
    age: number;
    member_id: number;
}

export interface PitPositionData {
    pitInLap: number;
    pitInPosition: number;
    pitOutPosition: number;
    pitPositionDifference: number;
    avgPitInPosition: number;
    avgPitOutPosition: number;
    avgPitPositionDifference: number;
}

export interface PitRoadAnalysis {
    vehicleNumber: string;
    driverFullName: string;
    bestTotalFourTires: number;
    bestTotalTwoTires: number;
    bestStopTwoTires: number;
    bestStopFourTires: number;
    avgStopTwoTires: number;
    avgStopFourTires: number;
    bestDriverTime: number;
    avgDriverTime: number;
    bestCrewTwoTires: number;
    bestCrewFourTires: number;
    avgCrewTwoTires: number;
    avgCrewFourTires: number;
    bestJackLeftTime: number;
    bestJackRightTime: number;
    avgJackLeftTime: number;
    avgJackRightTime: number;
    bestJackManTime: number;
    avgJackManTime: number;
}

export interface PitRoadData extends Message {
    vehicleNumber: string;
    lap: number;
    flagIn: string;
    flagOut: string;
    leftTime: number;
    rightTime: number;
    jackTime: number;
    crewTime: number;
    driverTime: number;
    driverEnter: number;
    driverGoes: number;
    vehicleStopToJack: number;
    jackToVehicleGoes: number;
    totalTime: number;
    tiresChanged: number;
    pitInTime: number;
    pitOutTime: number;
    missedEvents: number;
    sequence: string;
    leaderLap: number;
    driverFullName: string;
    pitStopType?: string;
    verifiedPitStopType?: string;
    source?: PitStrategySource;
    proPitStopType?: string;
    numberOfFuelCans?: number;
    leftSideAdjust?: boolean;
    rightSideAdjust?: boolean;
    rearLeftTireChanged?: boolean;
    rearRightTireChanged?: boolean;
    frontLeftTireChanged?: boolean;
    frontRightTireChanged?: boolean;
    pitBoxStopTime?: number;
    pitBoxLeaveTime?: number;
    pitStopDuration?: number;
    bodyRepairs?: boolean;
    infractions: string[];
    pitPositionMetadata: PitPositionData;
    greenInList: GreenCalc[];
    greenOutList: GreenCalc[];
}

export interface PitStrategy {
    flagIn: FlagType;
    flagOut: FlagType;
    leftTime: number;
    rightTime: number;
    jackTime: number;
    crewTime: number;
    driverEnterTime: number;
    driverTime: number;
    totalTime: number;
    tires: number;
    pitInTime: number;
    pitOutTime: number;
    missedEvents: number;
    sequence: string;
    carStopToJack: number;
    jackToCarGoes: number;
    driverGoes: number;
    pitStopType?: string;
    recordedTime: number;
    boxLeaveRaceTime: number;
    boxStopRaceTime: number;
    driverId: number;
    pitInTravelDuration: number;
    pitOutTravelDuration: number;
    pitInFlagStatus: FlagType;
    pitOutFlagStatus: FlagType;
    pitInPassingTime: number;
    pitInRaceTime: number;
    pitOutRaceTime: number;
    pitStopReportId: number;
    manufacturer: string;
    pitBoxStopTime?: number;
    pitBoxLeaveTime?: number;
    pitStopDuration?: number;
    changedDatetime: number;
    externalFactor: string;
    fuelStrategy: string;
    infractions: string[];
    rearLeftTireChanged?: boolean;
    rearRightTireChanged?: boolean;
    frontLeftTireChanged?: boolean;
    frontRightTireChanged?: boolean;
    numberOfFuelCans?: number;
    leftSideAdjust?: boolean;
    rightSideAdjust?: boolean;
    bodyRepairs?: boolean;
    isVerified?: boolean;
    isInvalid: boolean;
    source: PitStrategySource;
    verified: boolean;
    invalid: boolean;
}

export interface PitStrategyData extends Message {
    vehicleNumber: string;
    lap: number;
    leaderLap: number;
    driverName: string;
    pitStrategySourceMap: Record<PitStrategySource, PitStrategy>;
}

export interface PitStrategyDataResponse {
    pitStrategyDataList: PitStrategyData[];
}

export interface PreviousLapMetaData {
    lap: number;
    flag: FlagType;
    lapTime: number;
    slowLap: boolean;
}

export interface ProcessRaceReplayResponse {
    liveEventRunning: boolean;
    message: string;
    functionError: boolean;
}

export interface ProcessReplayRequest {
    sessionId?: string;
    originType: OriginType;
    eventId: string;
    runType: RunType;
    seriesType: SeriesType;
}

export interface QualifyingEntriesData {
    runningPosition: number;
    vehicleNumber: string;
    driverFullName: string;
    qualifyingGroupName: string;
    practiceGroupName: string;
}

export interface QualifyingEntriesDataResponse {
    qualifyingEntriesData: QualifyingEntriesData[];
}

export interface QualifyingLapData {
    runningPosition: number;
    vehicleNumber: string;
    driverFullName: string;
    deltaToTarget: number;
    lastLapTime: number;
    bestLapTime: number;
    timeOfDay: number;
    runName: string;
    isDatabaseRecord: boolean;
    vehicleStatus: string;
    messageType: string;
    isStartFinish: boolean;
    qualifyingPosition: number;
    lapsCompleted: number;
    startFinish: boolean;
    databaseRecord: boolean;
}

export interface QualifyingMetaData {
    groupsList: string[];
    totalRounds: number;
    lapsPerRound: number;
    isTimedSession: boolean;
    seriesId: string;
    timedSession: boolean;
}

export interface Race {
    runs: RunDetail[];
    race_id: number;
    series_id: number;
    race_season: number;
    race_name: string;
    race_type_id: number;
    restrictor_plate: boolean;
    track_id: number;
    track_name: string;
    date_scheduled: string;
    race_date: string;
    qualifying_date: string;
    tunein_date: string;
    scheduled_distance: number;
    actual_distance: number;
    scheduled_laps: number;
    actual_laps: number;
    stage_1_laps: number;
    stage_2_laps: number;
    stage_3_laps: number;
    number_of_cars_in_field: number;
    pole_winner_driver_id: number;
    pole_winner_speed: number;
    number_of_lead_changes: number;
    number_of_leaders: number;
    number_of_cautions: number;
    number_of_caution_laps: number;
    average_speed: number;
    total_race_time: string;
    margin_of_victory: string;
    race_purse: number;
    race_comments: string;
    attendance: number;
    results: RaceResult[];
    caution_segments: Caution[];
    race_leaders: LapLeader[];
    infractions: RaceInfraction[];
    schedule: RaceSchedule[];
    radio_broadcaster: string;
    television_broadcaster: string;
    satellite_radio_broadcaster: string;
    master_race_id: number;
    inspection_complete: boolean;
    playoff_round: number;
}

export interface RaceInfraction {
    car_number?: string;
    driver_fullname?: string;
    driver_id: number;
    lap: number;
    lap_assessed: number;
    infraction: string;
    penalty: string;
    notes: string;
}

export interface RaceProgressionData extends SessionProgression, Message {
}

export interface RaceResult {
    result_id: number;
    finishing_position: number;
    starting_position: number;
    car_number: string;
    driver_fullname: string;
    driver_id: number;
    driver_hometown: string;
    hometown_city: string;
    hometown_state: string;
    hometown_country: string;
    team_id: number;
    team_name: string;
    qualifying_order: number;
    qualifying_position: number;
    qualifying_speed: number;
    laps_led: number;
    times_led: number;
    car_make: string;
    car_model: string;
    sponsor: string;
    points_earned: number;
    bonus_points_earned: number;
    playoff_points_earned: number;
    laps_completed: number;
    finishing_status: string;
    winnings: number;
    series_id: number;
    race_season: number;
    race_id: number;
    owner_fullname: string;
    crew_chief_id: number;
    crew_chief_fullname: string;
    points_position: number;
    points_delta: number;
    owner_id: number;
    official_car_number: string;
    disqualified: boolean;
    diff_laps: number;
    diff_time: number;
    pit_box: number;
}

export interface RaceSchedule {
    event_name: string;
    notes: string;
    start_time_utc: string;
    run_type: number;
}

export interface RankAnalysisResponse {
    vehicleToLapMap: Record<string, Record<number, number>>;
    lapAnalysisMap: Record<number, LapAnalysisData>;
    lapAnalysisAverageMap: Record<string, LapAnalysisAvgSingle>;
    defaultLapAnalysisStats: LapAnalysisStats;
}

export interface ReplayRequest extends BaseRequest {
    eventId: string;
    sessionType: RunType;
}

export interface RoadCrewMember {
    full_name: string;
    position: string;
    home_track: string;
    age: number;
    member_id: number;
}

export interface Round {
    roundId: string;
    roundName: string;
    sequence: number;
    ruleId: string;
    totalTime: number;
    groupList: Group[];
}

export interface Rule {
    ruleId: string;
    ruleName: string;
    description: string;
}

export interface Run {
    id: number;
    event_id: number;
    race_uid: number;
    series: string;
    series_uid: number;
    name: string;
    type: number;
    ttl_laps: number;
    laps_rem: number;
    dur: number;
    tm_rem: number;
    act_start: string;
    sch_start: string;
    is_active: boolean;
    is_complete: boolean;
    complete: boolean;
    active: boolean;
}

export interface RunDetail {
    run_id: number;
    run_name: string;
    run_type: number;
    run_type_description: string;
    finish_at_lap: number;
    start_time: string;
    results: RunResult[];
}

export interface RunResult {
    result_id: number;
    starting_position: number;
    finishing_position: number;
    car_number: string;
    driver_fullname: string;
    competitor_id: number;
    make: string;
    sponsor: string;
    best_laptime: number;
    best_lap: number;
    best_speed: number;
    last_laptime: number;
    last_speed: number;
    laps: number;
    total_time: number;
}

export interface SanctioningBody {
    sanctioningBodyId: string;
    sanctioningBodyName: string;
    sanctioningBodySeriesIdsList: string[];
    sourceTypesList: number[];
}

export interface SanctioningBodyResponse {
    sanctioningBodiesList: SanctioningBody[];
    sanctioningBodySeriesList: SanctioningBodySeries[];
}

export interface SanctioningBodySeries {
    seriesId: string;
    seriesName: string;
}

export interface Schedule {
    start_time: string;
    end_time: string;
    event_name: string;
    race_id: number;
    track_id: number;
    track_name: string;
    race_name: string;
    series_id: number;
    run_type: number;
    start_time_utc: string;
    end_time_utc: string;
}

export interface Series {
    seriesId: string;
    seriesFullName: string;
    seriesShortName: string;
    seriesAbbreviation: string;
    seasons: string[];
}

export interface Session {
    sessionId: string;
    sessionType: RunType;
    sessionStatus: RunStatus;
    seriesId: string;
    sessionDescription: string;
}

export interface SessionCacheKey {
    seriesId: number;
    eventId: number;
    season: number;
}

export interface SessionDBInfo {
    sessionId: string;
    raceId: number;
    eventId: string;
    eventGroupId: string;
    sessionType: RunType;
    sequence: number;
    scheduledStartTimestamp?: Date;
    timeAllottedGroupA: number;
    timeAllottedTotal: number;
    description: string;
    numberOfLaps: number;
    raceStatusId: RunStatus;
    formatId?: string;
}

export interface SessionFormat {
    formatId: string;
    formatName: string;
    sessionType: string;
    rounds: string[];
    seriesId: number;
}

export interface SessionInfo {
    eventId: string;
    raceId?: number;
    runType: RunType;
    seriesId: string;
    eventName: string;
    feedSpecificRunName: string;
    seriesType: SeriesType;
    clientId: string;
    sessionId?: string;
    originType: OriginType;
}

export interface SessionPitRoadAnalysis {
    leaderLap: number;
    pitRoadAnalysis: PitRoadAnalysis[];
}

export interface SessionPitRoadAnalysisRequest {
    eventId: string;
    sessionType: RunType;
}

export interface SessionPitRoadAnalysisResponse {
    pitRoadAnalysis: SessionPitRoadAnalysis[];
}

export interface SessionPitRoadSummary {
    leaderLap: number;
    pitRoadData: PitRoadData[];
}

export interface SessionPitRoadSummaryResponse {
    pitRoadSummaryList: SessionPitRoadSummary[];
}

export interface SessionPitStrategyRequest extends ReplayRequest {
}

export interface SessionPitSummaryRequest extends ReplayRequest {
    originType: OriginType;
}

export interface SessionProgression {
    currentStage: number;
    lapNumber: number;
    totalLaps: number;
    timeElapsed: number;
    greenLapsFlagCount: number;
    yellowLapsFlagCount: number;
    totalStages: number;
    currentStageCurrentLap: number;
    currentStageTotalLaps: number;
    timeRemaining: number;
    flag: number;
    localTime: number;
}

export interface SessionProgressionRequest extends ReplayRequest {
}

export interface SessionProgressionResponse {
    progressionData: RaceProgressionData[];
}

export interface SessionTimingScoringData {
    leaderLap: number;
    leaderLapFlag: number;
    timestampMetadata: TimestampMetadata;
    sessionVehicleMetadataList: SessionTimingScoringVehicleMetaData[];
    driverCount: number;
    qualifyingRoundName: string;
}

export interface SessionTimingScoringRequest extends ReplayRequest {
}

export interface SessionTimingScoringResponse {
    sessionTimingScoringDataList: SessionTimingScoringData[];
}

export interface SessionTimingScoringVehicleMetaData {
    lapsCompleted: number;
    vehicleNumber: string;
    runningPosition: number;
    lastLapTime: number;
    slowLap: boolean;
    pitLap: boolean;
    flag: number;
    greenYellowFlag: boolean;
    fastestPosition: number;
    driverFullName: string;
    timeOfDay: number;
    deltaToTarget: number;
    lapsLed: number;
    bestLapTime: number;
    movingAverageLapTime: number;
    lapsToTarget?: number;
    vehicleStatus: string;
    messageType: string;
    isStartFinish: boolean;
    avgLapTime: number;
    fastRank: number;
    avgRank: number;
    runName: string;
    qualifyingPosition: number;
    isDatabaseRecord: boolean;
    gapMetadataList: GapMetadata[];
    elapsedTime: number;
    bestLap: number;
    startFinish: boolean;
    databaseRecord: boolean;
}

export interface SimpleLap extends MinimalLap {
    leaderLap: number;
    driverFullName: string;
    deltaToTarget: number;
    bestLapTime: number;
    isStartFinish: boolean;
    loopName: string;
    pitStopType?: string;
    lapsLed: number;
    movingAverageLapTime: number;
    lapsToTarget?: number;
    vehicleStatus: string;
    gapMetadataList: GapMetadata[];
    messageType: string;
    slowLap: boolean;
    greenYellowFlag: boolean;
    fastestPosition: number;
    lastPit?: number;
    lapsSincePit?: number;
    tireType?: string;
    overtakeRemaining?: number;
    pitStatus?: boolean;
    pitStrategySource?: PitStrategySource;
    bestLap: number;
}

export interface SimpleLapData extends SimpleLap {
    startFinish: boolean;
    pitLap: boolean;
}

export interface StreamHistoryRequest {
    originType: number;
    seriesType: number;
    runType: number;
    eventId: string;
}

export interface StreamInfo extends BasicSession {
    originType: OriginType;
}

export interface StreamInfoKt {
}

export interface SupportedStreams {
    sanctioningBody: SanctioningBodyEnum;
    supportedOrigins: OriginType[];
}

export interface TeamData {
    teamId: number;
    teamName: string;
    domain: string;
}

export interface TeamVehiclesData {
    vehicleNumber: string;
    teamId: number;
    manufacturerId: number;
}

export interface TelemetryData extends Message {
    vehicleNumber: string;
    vehicleManufacturer: string;
    latitude: number;
    longitude: number;
    heading: number;
    position: number;
    onLeadLap: boolean;
    isLuckyDog: boolean;
    gpsQuality: number;
    luckyDog: boolean;
}

export interface TextSearchRequest {
    searchTerm: string;
    exclude: boolean;
}

export interface TimestampMetadata {
    earliestTimestamp: number;
    latestTimestamp: number;
}

export interface TireAgeMetadata {
    lap: number;
    frontRight: number;
    frontLeft: number;
    rearRight: number;
    rearLeft: number;
    lsLaps: number;
    rsLaps: number;
}

export interface Track {
    trackId: string;
    trackName: string;
    trackCity: string;
    trackState: string;
    trackLatitude: number;
    trackLongitude: number;
    trackZoom: number;
    trackBearing: number;
    trackTimezone: string;
    trackLineCrossingList: LineCrossing[];
    trackAddress: string;
    trackZip: string;
    trackType: string;
    trackSurface: string;
    trackBanking: string;
    trackLength: string;
    trackDescription: string;
    yearBuilt: string;
    frontstretchLength: string;
    backstretchLength: string;
    cautionCarSpeed: string;
    schStartTsUtc: string;
    schEndTsUtc: string;
    aclStartTsUtc: string;
    aclEndTsUtc: string;
    qualifyingmetadataList: QualifyingMetaData[];
}

export interface TrackLocationData extends Message {
    vehicleNumber: string;
    distFromSF: number;
    position: number;
    onLeadLap: boolean;
    isLuckyDog: boolean;
    isInPit: boolean;
    lap: number;
    luckyDog: boolean;
    inPit: boolean;
}

export interface TrackTempHistoricListResponse {
    trackTempHistoricList: TrackTemperatureHistoricalListing[];
}

export interface TrackTemperatureData extends Message {
    recordingName?: string;
    trackName?: string;
    cameraName?: string;
    cameraLocation?: string;
    cameraTakeTs?: number;
    lowLineTemp?: string;
    middleLineTemp?: string;
    highLineTemp?: string;
    referenceTemp?: string;
    imageReferenceName?: string;
    id?: number;
    loopId?: number;
    lineCrossingName?: string;
    triggerId?: number;
    tempF?: number;
    tempC?: number;
    lat?: number;
    lon?: number;
    timestamp?: number;
}

export interface TrackTemperatureHistoricalListing {
    recordingName: string;
    trackName: string;
    trackTimezone: string;
    recordingDateRange: string;
}

export interface TrackTemperatureImageData {
    cameraName: string;
    base64Image: string;
}

export interface TrackTemperatureImageRequest {
    recordingName: string;
    imageReferenceName: string;
}

export interface TrackTemperatureImageResponse {
    trackTemperatureRowImage: TrackTemperatureImageData;
}

export interface TrackTemperatureTableRequest {
    currentEventTrackId: string;
    currentEventLatestRowTimestamp: string;
    currentEventDate: string;
    isReplay: boolean;
}

export interface TrackTemperatureTableResponse {
    trackTemperatureRow: TrackTemperatureTabularRowData[];
}

export interface TrackTemperatureTabularRowData {
    trackRecordingName: string;
    trackName: string;
    cameraName: string;
    cameraLocation: string;
    cameraTakeTimestamp: string;
    lowLineTemperature: string;
    middleLineTemperature: string;
    highLineTemperature: string;
    referenceTemperature: string;
    imageReferenceName: string;
}

export interface TrackUpdateRequest extends TrackUpdateRequestInterface {
}

export interface TrackUpdateRequestInterface {
    update: string;
    trackId: number;
}

export interface UIProcessReplayRequest {
    sessionId: string;
    runType: RunType;
    raceProgressionOriginType?: OriginType;
    timingScoringOriginType?: OriginType;
    pitSummaryOriginType?: OriginType;
    totalLaps?: number;
}

export interface UpdateIndyStationsResponse {
    status: boolean;
    message: string;
}

export interface UpdatePostgresByRaceIdsRequest {
    raceIds: number[];
}

export interface UpdateSessionInfoRequest {
    sessionDBInfo: SessionDBInfo;
}

export interface UpdateSessionInfoResponse {
    status: boolean;
    message: string;
}

export interface UserPreferenceResponse {
    data: string;
    createdBy?: string;
    createdTimestamp?: Date;
    updatedBy?: string;
    updatedTimestamp?: Date;
}

export interface UserPreferenceResponseStatus {
    status: boolean;
}

export interface VehicleMetaData {
    vehicleNumber: string;
    runningPosition: number;
    lastLapTime: number;
    slowLap: boolean;
    pitLap: boolean;
    flag: number;
    greenYellowFlag: boolean;
    fastestPosition: number;
    driverFullName: string;
    timeOfDay: number;
    bestLap: number;
    runName: string;
    elapsedTime: number;
    deltaToTarget: number;
    lapsLed: number;
    bestLapTime: number;
    movingAverageLapTime: number;
    lapsToTarget?: number;
    vehicleStatus: string;
    isStartFinish: boolean;
    leaderLap: number;
    lapsCompleted: number;
    tireAgeMetadata: TireAgeMetadata;
    startFinish: boolean;
}

export interface VehicleOemListResponse {
    oemList: string[];
}

export interface WeatherData extends Message {
    airTemp?: string;
    solRad?: number;
    humidity?: number;
    barometer?: number;
    adr?: number;
    windSpeed?: number;
    windDirection?: number;
    trackTempFaht?: number;
    lat?: number;
    lon?: number;
    timestamp?: number;
    stationId?: string;
    stationAlias?: string;
    looHeader: boolean;
    barTrend?: number;
    packetType?: string;
    insideTemperature?: number;
    insideHumidity?: number;
    outsideTemperature?: number;
    outsideHumidity?: number;
    tenMinAvgWindSpeed?: number;
    twoMinAvgWindSpeed?: number;
    tenMinWindGust?: number;
    windDirTenMinWindGust?: number;
    dewPoint?: number;
    heatIndex?: number;
    windChill?: number;
    rainRate?: number;
    stormRain?: number;
    startDateOfStorm?: string;
    dailyRain?: number;
    last15MinRain?: number;
    lastHourRain?: number;
    dailyET?: number;
    last24HourRain?: number;
    barometricReductionMethod?: number;
    userBarometricOffset?: number;
    barometricCalibrationNumber?: number;
    barometricSensorRawReading?: number;
    absoluteBarometricPressure?: number;
    altimeterSetting?: number;
    thswindex?: number;
    uvindex?: number;
    saecorrectionFactor?: number;
    THSWIndex?: number;
    UVIndex?: number;
    SAECorrectionFactor?: number;
}

export interface WeatherReplayResponse {
    weatherDataList: WeatherData[];
}

export interface Workspace {
    id: string;
    data: string;
    ownedBy: string;
    shared: boolean;
    createdBy: string;
    createdTimestamp: string;
    updatedBy: string;
    updatedTimestamp: string;
    sharedDomainsList: number[];
    ownedByDomain: string;
}

export interface WorkspaceInfo {
    id: string;
    name: string;
    slug: string;
    owner: string;
    shared: boolean;
    sharedDomains: number[];
    sanctioningBody: number;
}

export interface WorkspaceRequest {
    id: string;
    data: string;
    shared: boolean;
    sharedDomainsList: number[];
}

export interface WorkspaceResponseStatus {
    status: boolean;
}

export interface WorkspaceUpdateRequest extends WorkspaceUpdateRequestInterface {
}

export interface WorkspaceUpdateRequestInterface {
    workspaceId: string;
    workspaceUser: string;
    workspaceSettings: string;
    workspaceSlug: string;
    workspaceName: string;
    workspaceDisplay: string;
}

export interface AudioTranscriptionData extends Message {
    id: string;
    raceCode: string;
    raceSeries: string;
    raceSession: string;
    raceDate: string;
    driverName: string;
    driverNumber: string;
    audioStreamUrl: string;
    audioSnippetFilePath: string;
    transcriberSpeakerGroup: string;
    transcriberFinishedTimestampStr: string;
    transcriberFinishedTimestampMs: number;
    transcriberDisplayText: string;
    transcriberRecognitionStatus: string;
    transcriberOffset: number;
    transcriberDuration: number;
    transcriberSpeakerId: string;
    transcriberSpeakerType: string;
    transcriberUtteranceId: string;
    leaderLapNumber: number;
    categories: string[];
    copyTranscriberDisplayText: string;
}

export interface AudioTranscriptionRequest {
    eventId: string;
    runType: RunType;
    vehicleNumbers: string[];
    speakerRoles: SpeakersEnum[];
    searchQueries?: string[];
    categories?: string[];
    timestamp?: number;
    sort?: string;
    limit?: number;
}

export interface AudioTranscriptionStreamKey {
    eventId: string;
    runType: RunType;
}

export interface KeywordMatchedData {
    id: string;
    driverNumber: string;
    transcriberSpeakerGroup: SpeakersEnum;
    transcriberFinishedTimestampMs: number;
    transcriberDisplayText: string;
    leaderLapNumber: number;
    matchedKeywords: string[];
    copyTranscriberDisplayText: string;
}

export interface AzureBlobSasTokenRequest {
    tokenType: number;
    seriesCode?: string;
    eventDate?: string;
}

export interface DynamicImageRequest {
    seriesCode?: string;
    eventId?: string;
    filters?: Record<string, any>;
    pageNumber?: number;
    pageSize?: number;
    sort?: string;
}

export interface Image {
    id?: string;
    searchScore?: string;
    metadataStoragePath?: string;
    filepath: string;
    metadataStorageLastModified?: string;
    shutterTimeUnix?: number;
    creationTime?: string;
    imgName?: string;
    raceName?: string;
    sessionId?: string;
    photographerLocation?: string;
    detectedCars?: string[];
    lapNumber?: number;
    filteredText?: string[];
    numCarsDetected?: number;
    raceCode?: string;
    thumbnailUrl?: string;
}

export interface ImageFilter {
    mongoField: string;
    filterHeader: string;
    interactionType: InteractionType;
    valueMap?: Record<string, any[]>;
}

export interface ImageRequest {
    eventId: string;
    search?: string;
    sessionTypes?: string[];
    vehicles?: string[];
    numberOfVehicles?: string[];
    pageNumber?: number;
    pageSize?: number;
    sort?: string;
}

export interface ImageResponse {
    pageCount: number;
    imageCount: number;
    images: Image[];
}

export interface ImageStreamKey {
    eventId: string;
}

export interface FeedbackDetails {
    field: string;
    originalFieldValue: string;
    correctedFieldValue: string;
}

export interface Report {
    id: string;
    raceCode: string;
    raceSession: string;
    mediaId: string;
    mediaType: string;
    feedbackDetails: FeedbackDetails[];
    comments?: string;
    reporterName: string;
    reportTimestamp: number;
    reportState: string;
    stateModifiedBy: string;
    lastUpdatedTimestamp: number;
}

export interface UpdateStateRequest {
    id: string;
    reportState: ReportState;
}

export interface Comparable<T> {
}

export enum AdminSettingsId {
    UNRECOGNIZED,
    ALL_ADMIN_SETTINGS,
    AUDIO_TRANSCRIPTION,
    DEFAULT_WORKSPACE,
    RACE_PROGRESSION_ORIGINS,
}

export enum AlertTitle {
    UNKNOWN,
    PIT_ENTRY,
    PIT_EXIT,
    KEYWORD_DETECTED,
    FLAG_CHANGE,
    LUCKY_DOG_CHANGE,
}

export enum AlertType {
    UNKNOWN,
    FLAG,
    PIT,
    AUDIO,
    LUCKYDOG,
}

export enum FeedStatusType {
    UNKNOWN,
    GREEN,
    YELLOW,
    RED,
}

export enum FlagType {
    UNKNOWNFLAGTYPE,
    GREEN,
    YELLOW,
    RED,
    CHECKER,
    WHITE,
    STOP,
    REDBLACKCOMBO,
    WARM,
    UNFLAGGED,
}

export enum MapType {
    RING_OF_DOOM,
    LINE,
    MAP,
    FRAC_MAP,
}

export enum MessageType {
    UNKNOWN,
    RACE_PROGRESSION,
    LAP,
    TELEMETRY,
    PIT,
    DRIVER_POINTS,
    TRACK_TEMPERATURE,
    WEATHER,
    FEED_STATUS,
    TRACK_LOCATION,
    AUDIO,
    OWNER_POINTS,
    MANUFACTURER_POINTS,
}

export enum OriginType {
    UNKNOWN,
    SMT,
    MULTILOOP,
    RMONITOR,
    ERDP,
    STRATEGY,
    RIS,
    WEATHER_STATION,
    FEED_STATUS,
    DATA_SCIENCE_AUDIO,
    LIVE,
}

export enum PitStrategySource {
    UNKNOWN,
    PROPENALTY,
    PITRHO,
    SMT,
}

export enum RunStatus {
    UNKNOWN_RUN_STATUS,
    COMPLETED,
    LIVE,
    UNAVAILABLE,
    DATA_LOSS,
    CANCELED,
    REPLAY_ENABLED,
}

export enum RunType {
    UNKNOWNRUNTYPE,
    PRACTICE,
    QUALIFYING,
    RACE,
    TEST_EVENT,
}

export enum SanctioningBodyEnum {
    UNKNOWN,
    NASCAR,
    INDYCAR,
    IMSA,
    F1,
}

export enum SeriesType {
    UNKNOWN,
    CUP,
    XFINITY,
    TRUCK,
    IndyCar,
    IndyLights,
    IndyPro,
    Usf2000,
    MX5Cup,
    Formula1,
}

export enum SourceType {
    TELEMETRY_ENGINE,
    EMULATOR,
}

export enum TrackType {
    ROAD_COURSE,
    ROAD_CIRCUIT,
    SPEEDWAY,
    SUPERSPEEDWAY,
    RACE_CIRCUIT,
    STREET_CIRCUIT,
    SHORT_TRACK,
}

export enum SpeakersEnum {
    Driver,
    Crew_Chief,
    Spotter,
    Unidentified,
}

export enum MongoFieldType {
    UNKNOWN,
    SINGLE,
    ARRAY,
    OBJECT,
}

export enum MongoValueType {
    UNKNOWN,
    STRING,
    NUMBER,
}

export enum SasTokenTypeEnum {
    UNKNOWN,
    AUDIO,
    IMAGE_VIEWER,
}

export enum InteractionType {
    UNKNOWN,
    SINGLE_SELECT,
    MULTI_SELECT,
    INT_RANGE,
    DOUBLE_RANGE,
    VEHICLE_SELECTION,
    ORIENTATION,
    ID,
}

export enum ReportState {
    OPEN,
    CLOSED,
}
